import { useState } from "react";
import intl from "react-intl-universal";
import {
  TbCirclePlus,
  TbReceipt,
  TbTransfer,
  TbUsers,
} from "react-icons/tb";
import { ShortcutCard } from "../../../../../Components/Atoms/ShortcutCard";
import { BaasAccountTransferModal } from "./BaasAccountTransferModal";
import { BaasFundShellsButton } from "./BaasFundShellsButton";

/**
 * @param {object} props
 * @param {() => void} [props.onCreateClick]
 * @param {boolean} [props.transferEnabled] — true when any eligible source canTransferOut
 * @param {boolean} [props.transferOptionsLoading]
 */
export const BaasAccountsQuickActions = ({
  onCreateClick,
  transferEnabled = false,
  transferOptionsLoading = false,
  createEnabled = true,
  /** When false (viewer), hide Transferir entirely — do not show a disabled card. */
  transferVisible = true,
}) => {
  const [transferOpen, setTransferOpen] = useState(false);

  // Outbound Transferir when any eligible debit source exists — never because
  // a shell/reserve destination has balance.
  const transferDisabled = transferOptionsLoading || !transferEnabled;

  const actions = [
    createEnabled
      ? {
          id: "create",
          labelKey: "baas.accounts.quickActions.create",
          icon: TbCirclePlus,
          onClick: () => onCreateClick?.(),
        }
      : null,
    transferVisible
      ? {
          id: "transfer",
          labelKey: "baas.accounts.quickActions.transfer",
          icon: TbTransfer,
          disabled: transferDisabled,
          onClick: () => setTransferOpen(true),
        }
      : null,
    {
      id: "transactions",
      labelKey: "baas.accounts.quickActions.transactions",
      icon: TbReceipt,
      to: "/baas/transacoes",
    },
    {
      id: "entities",
      labelKey: "baas.accounts.quickActions.entities",
      icon: TbUsers,
      to: "/baas/entidades",
    },
  ].filter(Boolean);

  return (
    <section className="min-w-0 w-full">
      <p className="dashboard-section-label mb-3">
        {intl.get("baas.accounts.quickActionsSection")}
      </p>
      <div className="shortcut-scroll-row">
        {actions.map(({ id, labelKey, icon, to, onClick, disabled }) => (
          <ShortcutCard
            key={id}
            icon={icon}
            label={intl.get(labelKey)}
            to={to}
            onClick={onClick}
            disabled={disabled === true}
          />
        ))}
        {transferVisible ? <BaasFundShellsButton variant="shortcut" /> : null}
      </div>
      {transferVisible && transferDisabled && !transferOptionsLoading ? (
        <p className="mt-1.5 text-xs text-gray-500 dark:text-gray-400">
          {intl.get("baas.accounts.quickActions.transferDisabledHint")}
        </p>
      ) : null}

      <BaasAccountTransferModal
        open={transferOpen}
        onClose={() => setTransferOpen(false)}
      />
    </section>
  );
};
